import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ProcoreService {

	headerStatus = '';

	constructor(
		private http: HttpClient
	) { }

	getUserInfo(companyId: number, authCode: string, isSandbox: boolean) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('authCode', authCode);
		params = params.set('isSandbox', isSandbox);
		params = params.set('esignType', 'dropbox');

		const requestUrl = `${environment.serviceUrl}/procore/user-info`;

		return this.http.get<any>(requestUrl, { headers, params });
	}

	/**  */
	// getAccountType(companyId: number) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('companyId', companyId);

	// 	const requestUrl = `${environment.serviceUrl}/account-type`;

	// 	return this.http.get(requestUrl, { headers, params, responseType: 'text' });
	// }

	// getSignatures(companyId: number, context: string, userEmail: string) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('companyId', companyId);
	// 	params = params.set('context', context);
	// 	params = params.set('userEmail', userEmail);

	// 	const requestUrl = `${environment.serviceUrl}/signatures`;

	// 	return this.http.get<any[]>(requestUrl, { headers, params });
	// }

	// getSignatureRequest(companyId: number, signatureRequestId: string, userEmail: string) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('companyId', companyId);
	// 	params = params.set('signatureRequestId', signatureRequestId);
	// 	params = params.set('userEmail', userEmail);

	// 	const requestUrl = `${environment.serviceUrl}/signature-request`;

	// 	return this.http.get<any>(requestUrl, { headers, params });
	// }

	// NOT CURRENLY USED
	// getProjectName(companyId: number, projectId: number, isSandbox: boolean, username: string, procoreUserId: string) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('companyId', companyId);
	// 	params = params.set('projectId', projectId);
	// 	params = params.set('isSandbox', isSandbox);
	// 	params = params.set('username', username);
	// 	params = params.set('procoreUserId', procoreUserId);

	// 	const requestUrl = `${environment.serviceUrl}/procore/project/name`;

	// 	return this.http.get(requestUrl, { headers, params, responseType: 'text' });
	// }

	getProjectContractSigner(companyId: number, projectId: number, id: number, view: string, route: string, isSandbox: boolean, username: string, procoreUserId: string) {
		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('projectId', projectId);
		params = params.set('id', id);
		params = params.set('view', view);
		params = params.set('route', route);
		params = params.set('isSandbox', isSandbox);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);

		return this.http.get<any>(`${environment.serviceUrl}/procore/project/signer`, { params });
	}

	getProjectFolders(companyId: number, projectId: number, isSandbox: boolean, username: string, procoreUserId: string) {
		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('projectId', projectId);
		params = params.set('isSandbox', isSandbox);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);

		return this.http.get<any>(`${environment.serviceUrl}/procore/project/folders`, { params });
	}

	// For submittals
	// getSignatureRequestSignUrl(companyId: number, signatureRequestId: string, userEmail: string) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('companyId', companyId);
	// 	params = params.set('signatureRequestId', signatureRequestId);
	// 	params = params.set('userEmail', userEmail);

	// 	const requestUrl = `${environment.serviceUrl}/signature-request/sign-url`;

	// 	return this.http.get<any>(requestUrl, { headers, params });
	// }

	// For submittals
	// getSubmittal(companyId: number, projectId: number, submittalId: string, isSandbox: boolean) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('companyId', companyId);
	// 	params = params.set('projectId', projectId);
	// 	params = params.set('submittalId', submittalId);
	// 	params = params.set('isSandbox', isSandbox);

	// 	const requestUrl = `${environment.serviceUrl}/submittal`;

	// 	return this.http.get<any>(requestUrl, { headers, params });
	// }

	// For RFIs
	// getRfi(companyId: number, projectId: number, rfiId: string, isSandbox: boolean) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('companyId', companyId);
	// 	params = params.set('projectId', projectId);
	// 	params = params.set('rfiId', rfiId);
	// 	params = params.set('isSandbox', isSandbox);

	// 	const requestUrl = `${environment.serviceUrl}/rfi`;

	// 	return this.http.get<any>(requestUrl, { headers, params });
	// }

	getProjectUsers(companyId: string, projectId: number, isSandbox: boolean, username: string, procoreUserId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('projectId', projectId);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);
		params = params.set('isSandbox', isSandbox);

		const requestUrl = `${environment.serviceUrl}/procore/project/users`;

		return this.http.get<any[]>(requestUrl, { headers, params });
	}

	getAttachments(companyId: string, projectId: string, id: string, view: string, route: string, isSandbox: boolean, username: string, procoreUserId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('projectId', projectId);
		params = params.set('id', id);
		params = params.set('view', view);
		params = params.set('route', route);
		params = params.set('isSandbox', isSandbox);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);

		const requestUrl = `${environment.serviceUrl}/procore/attachments`;

		return this.http.get<any[]>(requestUrl, { headers, params });
	}

	getFilename(companyId: string, projectId: string, id: string, view: string, route: string, isSandbox: boolean, username: string, procoreUserId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('projectId', projectId);
		params = params.set('id', id);
		params = params.set('view', view);
		params = params.set('route', route);
		params = params.set('isSandbox', isSandbox);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);

		const requestUrl = `${environment.serviceUrl}/procore/filename`;

		return this.http.get<any>(requestUrl, { headers, params });
	}

	// createDropboxSignAuth(code: string, state: string) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('code', code);
	// 	params = params.set('state', state);

	// 	const requestUrl = `${environment.serviceUrl}/dropboxsign-auth`;

	// 	return this.http.post(requestUrl, '', { headers, params, responseType: 'text' });
	// }

	// NOT CURRENTLY USED
	// getDropboxSignUserExists(username: string) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('username', username);

	// 	const requestUrl = `${environment.serviceUrl}/dropboxsign-user-exists`;

	// 	return this.http.get<boolean>(requestUrl, { headers, params });
	// }

	// NOT CURRENTLY USED
	// getDropboxSignAuthUrl(username: string, companyId: number) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('username', username);
	// 	params = params.set('companyId', companyId);

	// 	const requestUrl = `${environment.serviceUrl}/dropboxsign-auth-url`;

	// 	return this.http.get(requestUrl, { headers, params, responseType: 'text' });
	// }

	// For submittals
	// createEmbeddedSignatureRequest(file: File, signatureInfo: any, isSandbox: boolean) {
	// 	let params = new HttpParams();
	// 	params = params.set('isSandbox', isSandbox);

	// 	const formData = new FormData();
	// 	if (file) {
	// 		formData.append('file', file, file.name);
	// 	}
	// 	formData.append('body', JSON.stringify(signatureInfo));

	// 	const requestUrl = `${environment.serviceUrl}/createEmbeddedSignatureRequest`;

	// 	return this.http.post(requestUrl, formData, { params });
	// }

	// NOT CURRENTLY USED
	// downloadGeneratedFile(fileContext: any, view: string, isSandbox: boolean, username: string, procoreUserId: string) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('isSandbox', isSandbox);
	// 	params = params.set('view', view);
	// 	params = params.set('esignType', 'dropbox');
	// 	params = params.set('username', username);
	// 	params = params.set('procoreUserId', procoreUserId);

	// 	const requestUrl = `${environment.serviceUrl}/procore/generated-file`;

	// 	return this.http.post(requestUrl, JSON.stringify(fileContext), { headers, params, responseType: 'text' });
	// }

	startGenerateFile(fileContext: any, view: string, isSandbox: boolean, username: string, procoreUserId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'text/plain');

		let params = new HttpParams();
		params = params.set('isSandbox', isSandbox);
		params = params.set('view', view);
		params = params.set('esignType', 'dropbox');
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);

		const requestUrl = `${environment.serviceUrl}/procore/generate-file`;

		return this.http.post(requestUrl, JSON.stringify(fileContext), { headers, params, responseType: 'text' });
	}

	// NOT CURRENTLY USED
	// endGenerateFile(url: string, companyId: string, view: string, isSandbox: boolean, username: string, procoreUserId: string) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'text/plain');

	// 	let params = new HttpParams();
	// 	params = params.set('url', url);
	// 	params = params.set('companyId', companyId);
	// 	params = params.set('isSandbox', isSandbox);
	// 	params = params.set('view', view);
	// 	params = params.set('esignType', 'dropbox');
	// 	params = params.set('username', username);
	// 	params = params.set('procoreUserId', procoreUserId);

	// 	const requestUrl = `${environment.serviceUrl}/procore/generate-file`;

	// 	return this.http.get(requestUrl, { headers, params, responseType: 'text' });
	// }

	// NOT CURRENTLY USED
	// getFile(signatureInfo: any, isSandbox: boolean, view: string) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('isSandbox', isSandbox);
	// 	params = params.set('view', view);

	// 	const requestUrl = `${environment.serviceUrl}/file`;

	// 	return this.http.post(requestUrl, JSON.stringify(signatureInfo), { headers, params, responseType: 'text' });
	// }

	// NOT CURRENTLY USED
	// getPackages() {
	// 	const params = new HttpParams();

	// 	return this.http.get<boolean>(`${environment.serviceUrl}/packages`, { params });
	// }
}
